export enum PostActionType {
  SendEmail = "SendEmail",
  SetMetadata = "SetMetadata",
  SetStatus = "SetStatus",
  IngestStart = "IngestStart",
}
